import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/newGama/Form'
import GamaFormSection from 'component/newGama/GamaFormSection'
import AccordionGama from 'component/utils/Accordion'
import Field from 'component/utils/Field'
import RegionBranchMultipleSelectNew from 'component/branch/RegionBranchMultipleSelectNew'
import { CustomMenuList as MenuList } from 'component/reactSelect/CustomMenuList'
import { CustomMultiValue as MultiValueContainer } from 'component/reactSelect/CustomMultiValue'
import Checkbox from 'component/Checkbox/newCheckbox'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'

const FirstParameterAdjust = (props) => {
  const { field, label, rightLabel, translate, setValueToField, allDisabled,placeholder, maxLength } =
    props

  return (
    <tr style={{padding: 0}} className={'mobiItem new-gama'}>
      <td>{translate(label)}</td>
      <td>
        <input
          placeholder={placeholder}
          disabled={allDisabled}
          maxLength={maxLength}
          value={field.input.value}
          onChange={(e) =>
            setValueToField(field.input.name, e.target.value.replace(/\D/, ''))
          }
          className='form-control'
          type='input'
        />
        &nbsp;&nbsp;&nbsp;
        {translate(rightLabel)}
      </td>
    </tr>
  )
}

FirstParameterAdjust.propTypes = {
  field: PropTypes.object,
  label: PropTypes.string,
  rightLabel: PropTypes.string,
  translate: PropTypes.func,
  setValueToField: PropTypes.func,
  allDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number
}

const SecondParameterAdjust = (props) => {
  const {
    field,
    checkboxField,
    daysField,
    percentageField,
    label,
    setValueToField,
    translate,
    allDisabled,
  } = props
  return (
    <tr className={'mobiItem percents'}>
      <td className='text-center'>
        <Checkbox
          disabled={allDisabled}
          onChange={(val) => {
            setValueToField(checkboxField, val)
            setValueToField(percentageField, '')
            daysField && setValueToField(daysField, '')
          }}
          checked={field[checkboxField].input.checked}
        />
      </td>
      <td>{translate(label)}</td>
      <td className='text-center'>
        {daysField && (
          <input
            placeholder='0'
            style={{width: '77px'}}
            disabled={!field[checkboxField].input.checked || allDisabled}
            id={'qqChanges'}
            maxLength={3}
            value={field[daysField].input.value}
            onChange={(event) => setValueToField(daysField, event.target.value)}
            className='form-control'
            type='input'
          />
        )}
      </td>
      <td className='text-center'>
        <input
          disabled={!field[checkboxField].input.checked || allDisabled}
          id={'qqChanges'}
          maxLength={3}
          style={{width: '77px'}}
          placeholder="0%"
          value={field[percentageField].input.value}
          onChange={(event) =>
            setValueToField(percentageField, event.target.value)
          }
          className='form-control'
          type='input'
        />
      </td>
    </tr>
  )
}

SecondParameterAdjust.propTypes = {
  field: PropTypes.object,
  checkboxField: PropTypes.string,
  daysField: PropTypes.string,
  percentageField: PropTypes.string,
  label: PropTypes.string,
  translate: PropTypes.func,
  setValueToField: PropTypes.func,
  allDisabled: PropTypes.bool,
  placeholder: PropTypes.string
}

const ALL = 'all'

const REQUIRED_FIELDS = [
  'nrItmDaySec',
  'nrRepeatDay',
  'nrJtDiff',
  'nrJtDiffRl',
  'nrItmStckLess',
  'nrItmLrgrStck',
  'nrMinVlrStck',
]

class GamaForm extends Component {
  state = {
    gamaSecModels: [],
    allDisabled: true,
  }

  areRequiredFieldsFilled = () => {
    const { fields } = this.props
    return REQUIRED_FIELDS.every((fieldName) => {
      const value = fields[fieldName]?.input?.value
      return value !== undefined && value !== null && value !== ''
    })
  }

  arePercentageFieldsFilled = () => {
    const { fields } = this.props

    const percentageValidations = [
      { checkbox: 'inItmWtSl', days: 'nrDayItmWtSl', percentage: 'nrItmWtSl' },
      { checkbox: 'inItmWtotSl', days: 'nrDayItmWtotSl', percentage: 'nrItmWtotSl' },
      { checkbox: 'inItmHighRisk', percentage: 'nrItmHighRisk' },
      { checkbox: 'inItmInAVs', percentage: 'nrItmInAvs' },
      { checkbox: 'inItmInTop2500', percentage: 'nrItmInTop2500' },
    ]

    return percentageValidations.every(({ checkbox, days, percentage }) => {
      const isChecked = fields[checkbox]?.input?.checked
      if (!isChecked) return true

      const percentageValue = fields[percentage]?.input?.value
      const isPercentageFilled = percentageValue !== undefined && percentageValue !== null && percentageValue !== ''

      if (days) {
        const daysValue = fields[days]?.input?.value
        const isDaysFilled = daysValue !== undefined && daysValue !== null && daysValue !== ''
        return isPercentageFilled && isDaysFilled
      }

      return isPercentageFilled
    })
  }

  get marcos() {
    const { fields } = this.props

    return [
      'nrItmWtSl',
      'nrItmWtotSl',
      'nrItmHighRisk',
      'nrItmInAvs',
      'nrItmInTop2500',

    ].reduce(
      (reduced, actual) =>
        reduced + parseFloat(fields[actual].input.value || 0),
      0.0
    )
  }

  setValueToField = (field, value) => {
    const { setValueToField } = this.props
    setValueToField(field, value)
    this.setState({ somethingTouched: true })
  }

  async componentDidMount() {
    // Get sections
    const sections = await this.getSections()

    if (sections.status) {
      await sections.data.map((sec) => {
        sec.inAll = false
      })

      this.setState({
        gamaSecModels: sections.data,
        gamaSecParams: {},
        loading: false,
        error: null,
      })
    } else {
      this.setState({
        gamaSecModels: [],
        loading: false,
        error: sections.error,
      })
    }

    this.populateGama(this.props.savedGama)
  }

  async componentWillReceiveProps(nextProps) {
    const { savedGama } = this.props

    if (nextProps.savedGama !== savedGama) {
      this.fillForm(nextProps)

      this.setState({
        savedGama: nextProps.savedGama,
      })

      const sections = await this.getSections()

      if (sections.status) {
        await sections.data.map((sec) => {
          sec.inAll = false
        })

        this.setState({
          gamaSecModels: sections.data,
          gamaSecParams: {},
          loading: false,
          error: null,
        })
      } else {
        this.setState({
          gamaSecModels: [],
          loading: false,
          error: sections.error,
        })
      }
    }
  }

  fillForm = (nextProps) => {
    const { setValueToField } = this.props

    setValueToField('nrItmDaySec', nextProps.savedGama.nrItmDaySec)
    setValueToField('inItmWtSl', nextProps.savedGama.inItmWtSl)
    setValueToField('inItmWtotSl', nextProps.savedGama.inItmWtotSl)
    setValueToField('inItmHighRisk', nextProps.savedGama.inItmHighRisk)
    setValueToField('inItmInAVs', nextProps.savedGama.inItmInAVs)
    setValueToField('nrItmWtSl', nextProps.savedGama.nrItmWtSl)
    setValueToField('nrItmWtotSl', nextProps.savedGama.nrItmWtotSl)
    setValueToField('nrItmHighRisk', nextProps.savedGama.nrItmHighRisk)
    setValueToField('nrItmInAvs', nextProps.savedGama.nrItmInAvs)
    setValueToField('nrDayItmWtSl', nextProps.savedGama.nrDayItmWtSl)
    setValueToField('nrDayItmWtotSl', nextProps.savedGama.nrDayItmWtotSl)
    setValueToField('inTopOne', nextProps.savedGama.inTopOne)
    setValueToField('inTopTwo', nextProps.savedGama.inTopTwo)
    setValueToField('inTopThree', nextProps.savedGama.inTopThree)
    setValueToField('nrRepeatDay', nextProps.savedGama.nrRepeatDay)
    setValueToField('nrJtDiff', nextProps.savedGama.nrJtDiff)
    setValueToField('nrJtDiffRl', nextProps.savedGama.nrJtDiffRl)
    setValueToField('nrItmStckLess', nextProps.savedGama.nrItmStckLess)
    setValueToField('nrItmLrgrStck', nextProps.savedGama.nrItmLrgrStck)
    setValueToField('nrMinVlrStck', nextProps.savedGama.nrMinVlrStck)
    setValueToField('nrItmInTop2500', nextProps.savedGama.nrItmInTop2500)
    setValueToField('inItmInTop2500', nextProps.savedGama.inItmInTop2500)

  }

  async clearForm() {
    const { setValueToField } = this.props

    setValueToField('nrItmDaySec', '')
    setValueToField('inItmWtSl', '')
    setValueToField('inItmWtotSl', '')
    setValueToField('inItmHighRisk', '')
    setValueToField('inItmInAVs', '')
    setValueToField('nrItmWtSl', '')
    setValueToField('nrItmWtotSl', '')
    setValueToField('nrItmHighRisk', '')
    setValueToField('nrItmInAvs', '')
    setValueToField('nrDayItmWtSl', '')
    setValueToField('nrDayItmWtotSl', '')
    setValueToField('inTopOne', '')
    setValueToField('inTopTwo', '')
    setValueToField('inTopThree', '')
    setValueToField('nrRepeatDay', '')
    setValueToField('nrJtDiff', '')
    setValueToField('nrJtDiffRl', '')
    setValueToField('nrItmStckLess', '')
    setValueToField('nrItmLrgrStck', '')
    setValueToField('nrMinVlrStck', '')
    setValueToField('nrItmInTop2500', '')
    setValueToField('inItmInTop2500', '')

    const sections = await this.getSections()

    if (sections.status) {
      await sections.data.map((sec) => {
        sec.inAll = false
      })

      this.setState({
        savedGama: {},
        gamaSecModels: sections.data,
        gamaSecParams: {},
        loading: false,
        error: null,
      })
    } else {
      this.setState({
        savedGama: {},
        gamaSecModels: [],
        loading: false,
        error: sections.error,
      })
    }
  }

  getSections = () => {
    const params = {
      level: 2,
      sectionId: 0,
      subSectionId: 0,
      typeId: 0,
      subTypeId: 0,
      limit: 50,
      offset: 0,
    }

    return this.fetchData(params)
  }

  fetchData = async (params) => {
    const {
      auth: { user },
    } = this.props
    /* istanbul ignore else */
    if (user) {
      this.setState({ loading: true })

      try {
        const { data } = await new Api(user.dsToken).post(
          API_URL.SECTIONS_HIERARCHY,
          params
        )
        return { status: true, data }
      } catch (error) {
        return { status: false, error }
      }
    }
  }

  populateGama = (savedGama) => {
    this.setState({ savedGama })
  }

  cleanFieldNumber = (disabled, fieldNumber) => {
    /* istanbul ignore else */
    if (disabled) {
      const { setValueToField } = this.props
      setValueToField(fieldNumber.input.name, '')
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { values, onSubmit } = this.props
    const { gamaSecModels } = this.selectChange.state

    const reduce = gamaSecModels.reduce(
      (acc, cur) => {
        /* istanbul ignore else */
        acc[0] = [
          ...acc[0],
          {
            sectionId: cur.sectionId,
            inAll: cur.inAll ? 1 : 0,
            description: cur.description,
          },
        ]

        if (cur.subSecOptions && cur.subSecOptions.selectedOptions) {
          acc[1] = [...acc[1], ...cur.subSecOptions.selectedOptions]
        }
        if (cur.typeOptions && cur.typeOptions.selectedOptions) {
          acc[2] = [...acc[2], ...cur.typeOptions.selectedOptions]
        }
        if (cur.subTypeOptions && cur.subTypeOptions.selectedOptions) {
          acc[3] = [...acc[3], ...cur.subTypeOptions.selectedOptions]
        }
        return acc
      },
      [[], [], [], []]
    )

    const ins = Object.keys(values).reduce((acc, cur) => {
      if (cur.startsWith('in')) {
        acc[cur] = values[cur] ? 1 : 0
      }
      if (cur.startsWith('nr')) {
        let aux = ''
        aux = !!values[cur] && values[cur].toString().replace('%', '')
        if (aux) {
          acc[cur] = aux.replace(',', '.')
        } else {
          acc[cur] = ''
        }
      }
      return acc
    }, [])

    const selectedBranches = values.listRegionsAndBranchs || []

    const gamaRegionsBranchsParams = []

    for (const option of selectedBranches) {
      if (option.value !== ALL) {
        const gamaRegionsBranchsParam = {
          idGama: null,
          branchRegion: option.value,
          dsBranchRegion: option.label,
          inRegion: option.isBranch === undefined ? 1 : 0,
        }

        gamaRegionsBranchsParams.push(gamaRegionsBranchsParam)
      }
    }

    const param = {
      ...values,
      ...ins,
      gamaSecParams: reduce[0],
      gamaSubSecParams: reduce[1],
      gamaTypeParams: reduce[2],
      gamaSubTypeParams: reduce[3],
      gamaRegionsBranchsParams,
      dsYear: moment().year(),
      wareHouseId: 'C050'
    }

    onSubmit(param)
  }

  branchChange = async (selectedOption, input) => {
    const { auth, fetchSections, setValueToField } = this.props

    input.value = selectedOption
    const event = { target: input }
    input.onChange(event)
    setValueToField('listRegionsAndBranchs', selectedOption)

    if (
      selectedOption.length === 1 &&
      selectedOption[0].value !== ALL &&
      selectedOption[0].isBranch !== undefined
    ) {
      const params = {
        level: 2,
        sectionId: 0,
        subSectionId: 0,
        typeId: 0,
        subTypeId: 0,
        limit: 50,
        offset: 0,
        gamaRegionsBranchsParams: [
          {
            idGama: null,
            branchRegion: selectedOption[0].value,
            inRegion: 0,
          },
        ],
        wareHouseId: 'C050'
      }

      await fetchSections(auth.user.dsToken, params).then(() => {
        this.setState({ loadedGama: true })
      })
      this.setState({ allDisabled: false, somethingTouched: false })
    } else {
      this.clearForm()
      if (
        selectedOption.length <= 1 &&
        !(selectedOption || []).some(({ idBranches }) => idBranches)
      )
        this.setState({ allDisabled: true, somethingTouched: false })
      else this.setState({ allDisabled: false, somethingTouched: false })
    }
  }

  render() {
    const {
      translate,
      auth: { user },
    } = this.props

    const field = this.props.fields

    const {
      gamaSecModels = [],
      savedGama,
      allDisabled,
      somethingTouched,
    } = this.state

    return (
      <Col md={10} mdOffset={1}>
        <form className='GamaForm-new'>
          <fieldset>
            <Row>
              <div className='margin-bottom margin-left-small margin-right-small custom-gama-select'>
                <Field {...field.listRegionsAndBranchs}>
                  <h4 className='no-margin'>
                    <b>{translate('scheduleBlock.branchs')}</b>
                  </h4>
                  <RegionBranchMultipleSelectNew
                    required
                    className="custom-gama-branchs"
                    id='listRegionsAndBranchs'
                    {...field.listRegionsAndBranchs.input}
                    placeholder='Selecione a loja'
                    components={{ MenuList, MultiValueContainer }}
                    translate={translate}
                    onChange={(event) =>
                      this.branchChange(
                        event.target.value,
                        field.listRegionsAndBranchs.input
                      )
                    }
                    excludeInactive={true}
                  />
                </Field>
              </div>
            </Row>
            <Row>
              <Col xs={12}>
                <h4 className='no-margin'>
                  <b>{translate('irc.gama.select.title')}</b>
                </h4>
                <br />
                <AccordionGama
                  className='accordion-gama-item'
                  title={translate('irc.gama.select.placeholder')}
                  size='md'
                >
                  <GamaFormSection
                    onSomethingChange={() => this.setState({ somethingTouched: true })}
                    allDisabled={allDisabled}
                    gamaSecModels={gamaSecModels}
                    savedGama={savedGama}
                    translate={translate}
                    user={user}
                    ref={(c) => {
                      this.selectChange = c
                    }}
                  />
                </AccordionGama>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <h4 className='no-margin'>
                  <b>{translate('mobile.ponctual.title')}</b>
                </h4>
                <div className={'mobiCard'}>
                  <table cellPadding='0' cellSpacing='0' className='new-table new-gama'>
                    <thead>
                      <tr>
                        <th scope={'col'} colSpan='1'>
                          {translate('parameter')}
                        </th>
                        <th colSpan='4'>
                          {translate('newPriceBannerFragment.values')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <FirstParameterAdjust
                        allDisabled={allDisabled}
                        placeholder="0"
                        maxLength={3}
                        label='irc.gama.labelItemQtyDaySection'
                        rightLabel='lmexpress.items'
                        field={field.nrItmDaySec}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                        placeholder="0"
                        allDisabled={allDisabled}
                        maxLength={3}
                        label='irc.gama.labelDontRepeatLM'
                        rightLabel='irc.gama.labelDays'
                        field={field.nrRepeatDay}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                         placeholder="0%"
                        allDisabled={allDisabled}
                        maxLength={3}
                        label='irc.gama.labelJustificationDifference'
                        rightLabel='irc.gama.labelJustificationDifferencePercentage'
                        field={field.nrJtDiff}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                         placeholder="0,00"
                        allDisabled={allDisabled}
                        maxLength={5}
                        label='irc.gama.justificationPerRealDifference'
                        rightLabel='irc.gama.labeljustificationPerRealDifference'
                        field={field.nrJtDiffRl}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                        placeholder="0"
                        allDisabled={allDisabled}
                        maxLength={8}
                        label='irc.gama.labelItemWithLowerStock'
                        rightLabel='irc.gama.labelItemWithHighterStock.unit'
                        field={field.nrItmStckLess}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                        placeholder="0"
                        allDisabled={allDisabled}
                        maxLength={5}
                        label='irc.gama.labelItemWithHighterStock'
                        rightLabel='irc.gama.labelItemWithHighterStock.unit'
                        field={field.nrItmLrgrStck}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                      <FirstParameterAdjust
                        placeholder="0,00"
                        allDisabled={allDisabled}
                        maxLength={6}
                        label='irc.gama.labelItemWithLowerValue'
                        rightLabel='irc.gama.labelItemWithLowerValue.unit'
                        field={field.nrMinVlrStck}
                        setValueToField={this.setValueToField}
                        translate={translate}
                      />
                    </tbody>
                  </table>
                </div>
                <h4 className='no-margin'>
                  <b>{translate('irc.gama.select.one.top')}</b>
                </h4>
                <div className={'mobiCard'}>
                  <Row>
                    <Col md={2}>
                      <Checkbox
                        className={'new-check-gama'}
                        disabled={allDisabled}
                        onChange={(val) =>
                          this.setValueToField('inTopOne', val)
                        }
                        checked={field.inTopOne.input.value}
                        name='inAVS'
                        label={translate('irc.gama.labelTop0')}
                      />
                    </Col>
                    <Col md={2}>
                      <Checkbox
                        className={'new-check-gama'}
                        disabled={allDisabled}
                        onChange={(val) =>
                          this.setValueToField('inTopTwo', val)
                        }
                        checked={field.inTopTwo.input.value}
                        name='inTop2500'
                        label={translate('irc.gama.labelTop1')}
                      />
                    </Col>
                    <Col md={2}>
                      <Checkbox
                        className={'new-check-gama'}
                        disabled={allDisabled}
                        onChange={(val) =>
                          this.setValueToField('inTopThree', val)
                        }
                        checked={field.inTopThree.input.value}
                        name='inMDH'
                        label={translate('irc.gama.labelTop2')}
                      />
                    </Col>
                  </Row>
                </div>
                <h4 className='no-margin'>
                  <b>{translate('irc.gama.complete.100')}</b>
                </h4>
                <div className={'mobiCard'}>
                  <table cellPadding='0' cellSpacing='0' className='new-table new-gama'>
                    <thead>
                      <tr className='params-label'>
                        <th className='text-center'>{translate('Ativar')}</th>
                        <th>{translate('parameter')}</th>
                        <th className='text-center'>
                          {translate('Quantidade de dias')}
                        </th>
                        <th className='text-center'>
                          {translate('Porcentagem')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <SecondParameterAdjust
                        allDisabled={allDisabled}
                        translate={translate}
                        field={field}
                        setValueToField={this.setValueToField}
                        label='irc.gama.labelItemsWithSale'
                        checkboxField='inItmWtSl'
                        daysField='nrDayItmWtSl'
                        percentageField='nrItmWtSl'
                      />
                      <SecondParameterAdjust
                        allDisabled={allDisabled}
                        translate={translate}
                        field={field}
                        setValueToField={this.setValueToField}
                        label='irc.gama.labelItemsWithoutSale'
                        checkboxField='inItmWtotSl'
                        daysField='nrDayItmWtotSl'
                        percentageField='nrItmWtotSl'
                      />
                      <SecondParameterAdjust
                        allDisabled={allDisabled}
                        translate={translate}
                        field={field}
                        setValueToField={this.setValueToField}
                        label='irc.gama.labelHighRiskProducts'
                        checkboxField='inItmHighRisk'
                        percentageField='nrItmHighRisk'
                      />

                      <SecondParameterAdjust
                        allDisabled={allDisabled}
                        translate={translate}
                        field={field}
                        setValueToField={this.setValueToField}
                        label='irc.gama.labelItemsInAVS'
                        checkboxField='inItmInAVs'
                        percentageField='nrItmInAvs'
                      />
                      <SecondParameterAdjust
                        allDisabled={allDisabled}
                        translate={translate}
                        field={field}
                        setValueToField={this.setValueToField}
                        label='irc.gama.labelItemsInTop2500'
                        checkboxField='inItmInTop2500'
                        percentageField='nrItmInTop2500'
                      />

                      <tr  className='tr-total'>
                        <td className='text-center'>
                          <h4 style={{fontWeight: 700, fontSize:'18px', paddingLeft: '16px', color: "#4E4E4E"}}>Total</h4>
                        </td>
                        <td />
                        <td />
                        <td className='text-center'>
                          <h4 style={{fontWeight: 700, fontSize: '18px', color: "#4E4E4E"}} >{this.marcos}%</h4>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row className='margin-top-double margin-bottom'>
              <Col md={2} mdOffset={8}>
                <button
                  role='button'
                  type='button'
                  className='btn btn-danger-outline button-full'
                  onClick={() =>
                    this.branchChange([], field.listRegionsAndBranchs.input)
                  }
                >
                  {translate('Limpar')}
                </button>
              </Col>
              <Col md={2}>
                <button
                  role='button'
                  type='button'
                  className='btn btn-primary button-full'
                  disabled={
                    (field.listRegionsAndBranchs !== undefined &&
                      field.listRegionsAndBranchs.input.value.length < 1) ||
                    this.marcos !== 100 ||
                    !somethingTouched ||
                    !this.areRequiredFieldsFilled() ||
                    !this.arePercentageFieldsFilled()
                  }
                  onClick={this.handleSubmit}
                >
                  {translate('save_button_label')}
                </button>
              </Col>
            </Row>
          </fieldset>
        </form>
        <br />
        <br />
      </Col>
    )
  }
}

GamaForm.propTypes = {
  fields: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  savedGama: PropTypes.object,
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.object,
  fetchSections: PropTypes.func.isRequired,
}

const fields = [
  'inItmWtSl',
  'inItmWtotSl',
  'inItmHighRisk',
  'inItmInAVs',
  'nrItmWtSl',
  'nrItmWtotSl',
  'nrItmHighRisk',
  'nrItmInAvs',
  'nrDayItmWtSl',
  'nrDayItmWtotSl',
  'inTopOne',
  'inTopTwo',
  'inTopThree',
  'nrItmDaySec',
  'nrRepeatDay',
  'nrJtDiff',
  'nrJtDiffRl',
  'nrItmStckLess',
  'nrItmLrgrStck',
  'nrMinVlrStck',
  'nrItmInTop2500',
  'inItmInTop2500',
  'listRegionsAndBranchs',

]

export default Form({ fields })(GamaForm)

export { GamaForm }
